import { HeatmapSummaryDto, ProjectHeatmapSettingDto } from "app/ApiClient";
import { LoadingState } from "types/loadingState";


export interface ProjectHeatmapState {
  loading: LoadingState;
  allProjectHeatmapSettings: HeatmapSummaryDto[];
  projectHeatmapSettings: HeatmapSummaryDto[];
  filters: Partial<Record<keyof HeatmapSummaryDto, string[]>>;
  relabeledHeatmapNameState: Record<string, LoadingState>;
  editedHeatmaps: Set<number>;
  currentHeatmapSettings?: ProjectHeatmapSettingDto;
};

export const initialProjectHeatmapState: ProjectHeatmapState = {
  loading: LoadingState.idle,
  allProjectHeatmapSettings: [],
  projectHeatmapSettings: [],
  filters: {},
  relabeledHeatmapNameState: {},
  editedHeatmaps: new Set<number>(),
};
